export default __webpack_public_path__ + "static/titilliumweb-bold-webfont-56891b473c7e7cefa0b1a24311b100e8.woff2";